import { TableCell, TableHead, TableRow } from '@material-ui/core';
import { FunctionComponent, useState } from 'react';

import ActualityAdditionalArgs from '../../../../../Types/Interface/TableInterfaces/AdditionalArgsInterface/ActualityAdditionalArgs';
import { ActualityInterface } from '../../../../../Types/Interface/TableInterfaces/DataInterface/DataInterface';
import ListHeaderProps from '../../../../../Types/Interface/Props/ListHeaderProps';
import GetHandleFilter from '../../../../../Methods/TableQuery/HandleFilter/GetHandleFilter';
import SearchBox from '../../SearchBox';
import ListHeaderOrder from './ListHeaderOrder';
import { HeadCell } from '../../../../../Types/BeecomingTypes/BeecomingTypes';

const ListHeaderActuality: FunctionComponent<
  ListHeaderProps<ActualityInterface, ActualityAdditionalArgs>
> = ({
  additionalArgs,
  onChangeAdditionalArgs,
  orderType,
  onChangeOrderType,
  orderBy,
  onChangeOrderBy,
}) => {
  const [timer, setTimer] = useState(setTimeout(() => {}, 0));

  const headCells: HeadCell<ActualityInterface>[] = [
    { id: 0, keyValue: 'level', name: 'A la une', align: 'center' },
    { id: 1, keyValue: 'title', name: 'Actualités du flux RSS', align: 'left' },
    { id: 2, keyValue: 'published', name: 'Date de publication', align: 'center' },
    { id: 3, keyValue: 'level', name: "Afficher sur l'application", align: 'center' },
    { id: 4, keyValue: 'level', name: 'Mise en avant', align: 'center' },
  ];
  return (
    <TableHead>
      <TableRow>
        <TableCell width={100} />
        <TableCell>
          <SearchBox
            label="Trouver une actualité"
            handleSearch={GetHandleFilter<ActualityAdditionalArgs>(
              'title',
              additionalArgs,
              onChangeAdditionalArgs,
              timer,
              setTimer,
              500,
            )}
          />
        </TableCell>
        <TableCell />
      </TableRow>
      <ListHeaderOrder
        headCells={headCells}
        orderType={orderType}
        onChangeOrderType={onChangeOrderType}
        orderBy={orderBy}
        onChangeOrderBy={onChangeOrderBy}
      />
    </TableHead>
  );
};

export default ListHeaderActuality;
